/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import GroupAudioCallPartipate from './GroupAudioCallParticipate';
import CallEndIcon from '@mui/icons-material/CallEnd';
import PhoneIcon from '@mui/icons-material/Phone';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeMuteIcon from '@mui/icons-material/VolumeMute';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import '../../../UiStyles/Animation/styles.css';
import '../../../UiStyles/CallScreen/styles.css';
import './../styles.css';
import { LoginContext } from '../../../App';
import { useSelector } from 'react-redux';
import { LanguageContext } from '../../../libs/Context';
import { Image } from '../../../libs/CustomHooks/Image';
import Conference from '../../../containers/Conference';
const GroupAudioCallScreen = (props) =>
{
	const { language } = useContext(LanguageContext);
	const [ speaker, setSpeaker ] = useState(false);
	const [ roomDetails, setRoomDetails ] = useState<any>(null);
	const [ participate, setParticipate ] = useState<boolean>(false);
	const { socket, call, setCall } = useContext(LoginContext);
	const userData = useSelector((state:any) => state?.mysession?.session);
	const callTimer = useRef<any>(null);

	const handleSpeaker = () =>
	{
		setSpeaker(!speaker);
	};
	const handleOpen = () =>
	{
		setParticipate(!participate);
	};

	const onReject = () =>
	{
		socket.emit('end_call_before_connect', { roomId: call?.roomId });
		setCall({ state: false, type: null, roomId: null, callBy: null, members: null });
	};

	const runTimer = () =>
	{
		callTimer.current = setTimeout(() =>
		{
			onReject();
		}, 30000);
	};

	const onCallAgain = (userId) =>
	{
		socket.emit('group_try_again_call', { roomId: call?.roomId, userId });

		if (!call?.inapi)
		{
			clearTimeout(callTimer.current);
			runTimer();
		}
	};

	useEffect(() =>
	{
		if (!call?.inapi)
		{
			runTimer();
		}

		return () =>
		{
			clearTimeout(callTimer.current);
		};
	}, []);

	useEffect(() =>
	{
		if (call?.inapi)
		{
			clearTimeout(callTimer.current);
		}
	}, [ call ]);

	useEffect(() =>
	{
		if (call?.custom)
		{
			setRoomDetails(call?.roomDetails[userData?.companyId]);
		}
		else
		{
			setRoomDetails(call?.roomDetails);
		}
	}, []);

	const acceptIncCall = useCallback(async (data) =>
	{
		if (call?.roomId === data?.roomId)
		{
			if (data?.roomType === 'group')
			{
				if (!call?.inapi)
				{
					setCall({ ...data, status: true });
				}
				else
				{
					setCall({ ...call, roomUsers: data?.roomUsers, inapi: data?.inapi });
				}
			}
		}
	}, [ socket, call ]);

	useEffect(() =>
	{
		if (socket)
		{
			socket.on('accept_inc_call', acceptIncCall);
			socket.on('reject_inc_call', (data) =>
			{
				if (call?.roomId === data?.roomId && call?.roomType === 'group')
				{
					setCall({ status: false, type: null, callBy: null, roomId: null });
				}
			});
		}

		return () =>
		{
			socket.off('accept_inc_call');
			socket.off('reject_inc_call');
		};
	}, [ socket, call ]);

	const checkCallApi = `flexCol ${!call?.inapi ? 'withoutparticipateCallSlider' : 'withoutBtnCallSlider  maxHeightCallScreen callSliderIn'} `;

	return (
		<>
			{roomDetails &&
			<div className='flexRow fixedFullScreenOverlay alignCntr justifyCntr '>
				<div className={`flexCol callScreen justifyBtwn ${call?.inapi && call?.type === 'video' && 'fullCallScreen'}`}>
					{!call?.inapi && <div className='flexMinWidthCol pdngTNodata'>
						<div className='flexRow alignCntr justifyCntr'>
							<div className='flexInline pdngHSM'>
								<PhoneIcon className='whiteTxt' />
							</div>
							<span className='subHeadingSM whiteTxt textCntr'>
								{props?.label}
							</span>
						</div>
						<div className='flexInline pdngTLG'>
							<div className='callAnimation'>
								<Image src={roomDetails?.groupPic || '/images/icons/defaultUser.svg'} alt='user' fallback={<img src='/images/icons/defaultUser.svg' alt='fallback'/>}/>
							</div>
						</div>
						<div className='flexCol alignCntr justifyCntr pdngTLG'>
							<h2 className='mainHdngTxt whiteTxt textCntr capitalTxt'>
								{roomDetails?.groupName || roomDetails?.name}
							</h2>
							<span className='subHeadingSM textCntr whiteLightTxt pdngTXS capitalTxt'>
								{language?.waitforot}
								{call?.callstatus}
							</span>
						</div>
					</div>}
					{call?.inapi &&
					<Conference token={call?.inapi?.token} session={call?.inapi?.session} callType={call?.type}/>
					}
					<button tabIndex={0} className={participate ? 'flexRow alignCntr justifyCntr overlaySliderCallScreen fadeInOverlay' : ''} onKeyUp={(e) => e.key === 'Enter' && setParticipate(!participate)} onClick={() => { setParticipate(!participate); }}/>
					<div
						className={
							participate
								? 'flexCol participateCallSlider maxHeightCallScreen slideOut'
								: checkCallApi
						}
					>
						<div className='flexCol alignCntr'>
							<div className='flexRow alignCntr justifyCntr pointer brdrBWhiteL'>
								<button
									tabIndex={0}
									onKeyUp={(e) => e.key === 'Enter' && handleOpen()}
									className='flexInline'
									onClick={handleOpen}
								>
									{participate
										? (
											<KeyboardArrowDownIcon
												fontSize='large'
												className='whiteLightTxt'
											/>
										)
										: (
											<KeyboardArrowUpIcon fontSize='large' className='whiteLightTxt' />
										)}
								</button>
							</div>
							{!call?.inapi &&

							<div className='flexRow pdngBXS justifyAround'>
								<button
									className='flexInline pdngSM alignCntr justifyCntr'
									onClick={handleSpeaker}
									tabIndex={0}
									onKeyUp={(e) => e.key === 'Enter' && handleSpeaker()}
								>
									{speaker
										? (
											<div className='flexInline callBtn alignCntr justifyCntr'>
												<VolumeMuteIcon fontSize='large' className='whiteTxt ' />
											</div>
										)
										: (
											<div className='flexInline callBtnWhite alignCntr justifyCntr'>
												<VolumeUpIcon
													fontSize='large'
												/>
											</div>
										)}
								</button>
								<button tabIndex={0} className='flexInline pdngHSM alignCntr justifyCntr ' onKeyUp={(e) => e.key === 'Enter' && onReject()} onClick={onReject}>
									<div className='flexInline callBtn endCallBtn alignCntr justifyCntr'>
										<CallEndIcon fontSize='large' className='whiteTxt' />
									</div>
								</button>
							</div>

							}
							{participate && <GroupAudioCallPartipate onCallAgain={onCallAgain} roomMembers={call?.roomUsers}/>}
						</div>
					</div>
					{!call.inapi &&
					<audio id='ringer' autoPlay loop muted={call?.callStatus === 'ongoing' || (call?.callStatus !== 'ongoing' && speaker)}>
						<source src='/audio/ringone.mp3' type='audio/mpeg' />
						<source src='/audio/ringtwo.wav' type='audio/mpeg' />
						<track src='' kind='subtitles' srcLang='en' label='English' />
					</audio>}
				</div>
			</div>}

		</>
	);
};

export default GroupAudioCallScreen;
